import { Table } from '@mantine/core';
import { useSelector } from 'react-redux';
import formatDate from '../../constants/formattedDate';
import AvatarInitials from '../AvatarInitials';

const CompanyRows = ({ companies }) => {
  const { domain } = useSelector((state) => state.domain);

  return companies.map((company, index) => (
    <Table.Tr key={index}>
      <Table.Td>
        <div style={{ display: 'inline-block', verticalAlign: 'middle', margin: 0 }}>
          <AvatarInitials user={company} />
        </div>
        &nbsp;&nbsp;
        <a
          href={`#/accounts/${domain.accountId}/domains/${domain.id}/companies/${encodeURIComponent(
            company.companyId
          )}/events`}
          data-tour={index === 0 ? 'companiesPageFirstCompanyLink' : undefined}
        >
          <strong>{company.name}</strong>
        </a>
      </Table.Td>
      <Table.Td>{company.email}</Table.Td>
      <Table.Td>{company.phoneNumber}</Table.Td>
      <Table.Td>{formatDate(company?.timestamp)}</Table.Td>
    </Table.Tr>
  ));
};

export default CompanyRows;
